import { useQuery } from '@tanstack/react-query';

import { getValidatedSenderCountries } from '../settings.service';

export const validatedSenderCountriesKeys = {
  bySenderId: (senderId: string) => ['alphaSenders', 'countries', senderId] as const,
};

export const useValidatedSenderCountries = (senderId: string) => {
  return useQuery({
    enabled: !!senderId,
    queryFn: () => getValidatedSenderCountries(senderId),
    queryKey: validatedSenderCountriesKeys.bySenderId(senderId),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
};
